/**
 * 应用配置
 * 
 * 说明：
 * - 所有配置都从环境变量读取，不设置硬编码的默认值
 * - 环境变量定义在 .env.development 或 .env.production 中
 * - 如果环境变量未设置，会在控制台输出警告
 * 
 * 使用方式：
 * import config from '@/config';
 * const apiUrl = config.apiBaseUrl;
 */

// 从环境变量读取配置
const getApiBaseUrl = () => {
  const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
  if (!apiBaseUrl) {
    console.warn('警告: VUE_APP_API_BASE_URL 未设置，请在 .env 文件中配置');
  }
  return apiBaseUrl;
};

const getBaseUrl = () => {
  return process.env.BASE_URL || '/';
};

// 统一配置对象
const config = {
  // API 基础地址
  apiBaseUrl: getApiBaseUrl(),
  // 应用基础路径
  baseUrl: getBaseUrl(),
  // 当前环境
  env: process.env.NODE_ENV || 'development',
  // 是否为生产环境
  isProduction: process.env.NODE_ENV === 'production'
};

export default config;

